
import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect }  from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import { languageManager } from '../utils/languageManager'
import { closeConfig } from '../App/actions'

import {platformHandler} from '../platforms/PlatformHandler'



import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';


import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import Button from '@material-ui/core/Button';

import { COLOR } from '../App/constants';

import { closeModalWindow } from '../App/actions'

const styles = theme => ({  
    paperTitle: {
      backgroundColor: COLOR.FLIPWIT_COLOR_2,
      color: 'black',
      height: '50px',
      display: 'flex',
      alignItems: 'center',      
      width: '100%',
      overflow: 'hidden',
      flexShrink: 0,
      position: "sticky",
      zIndex: "2",
    }, 
    labelTitlePaper: {
      display: 'flex',
      alignItems: 'inherit',
      fontSize: '1.3em',
      color: 'white',
      margin: theme.spacing.unit+"px "+(theme.spacing.unit*2)+'px',
      overflow: 'hidden',
    },
    labelDescPaper: {
      alignSelf: 'self-start',
      margin: theme.spacing.unit*3,
    },    
    configContainer: {
      width: '100%',
      flexShrink: 0,
      flexDirection: 'column',
      display: 'flex',      
    },
    paperDialog: {      
      minWidth: 200, 
    },
    configItemBlock: {
      margin: theme.spacing.unit,
      padding: theme.spacing.unit,
      border: '2px solid #CCC',
      flexDirection: 'row',
      flexShrink: 0,
      alignItems: 'center',
      ['@media (min-width: 400px)']: {
        display: 'flex',        
      }
    },
    configQuestionsBlock: {
      margin: theme.spacing.unit,
      padding: theme.spacing.unit,
      border: '2px solid #CCC',
      flexDirection: 'column',
      flexShrink: 0,
      alignItems: 'center',
      ['@media (min-width: 400px)']: {
        display: 'flex',        
      }
    },
    configQuestions: {
      flexDirection: 'row',
      flexShrink: 0,
      alignItems: 'center',
      ['@media (min-width: 400px)']: {
        display: 'flex',        
      }
    },
    configModerator: {
      marginTop: theme.spacing.unit,
      marginLeft: theme.spacing.unit*2,
      marginRight: theme.spacing.unit*2,
      padding: theme.spacing.unit,
      border: '2px solid #CCC',
      flexDirection: 'row',
      flexShrink: 0,
      alignItems: 'center',
      ['@media (min-width: 400px)']: {
        display: 'flex',        
      }
    },
    configItemTitle: {
      fontWeight: 700,
      marginBottom: theme.spacing.unit,
    },
    configItemDesc: {
      fontSize: '0.9em',
    },
    allItemsContainer: {
      overflow: 'hidden auto',
      display: 'flex',  
      flexDirection: 'column',    
    },
    switchContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',   
      padding: theme.spacing.unit,
      border: '2px solid #DDD',         
    },
    instructionContainer: {
      padding: theme.spacing.unit,      
    },
    menuButton: {
      color: 'white',
      marginLeft: theme.spacing.unit,
      /*marginLeft: 0,
      marginRight: 20,
      height: 64,
      overflow: 'visible',
      display: 'flex',
      alignSelf: 'self-start',*/
    },    
    shareBox: {
      border: 'solid 1px lightgray',
      width: '100%',
      padding: '10px',
      fontSize: '0.9em',
      marginTop: '10px',
    }
});

/*const FW_theme = createMuiTheme({  
   palette: {
    primary: {
      light: '#FFF',
      main: '#FFF',
      dark: '#FFF',
      contrastText: '#FFF',
    },
    secondary: {
      light: COLOR.FLIPWIT_COLOR_1,
      main: COLOR.FLIPWIT_COLOR_1,
      dark: COLOR.FLIPWIT_COLOR_1,
      contrastText: COLOR.FLIPWIT_COLOR_1,
    }
  },
});*/

/*const styles = theme => ({  
});*/


class FwSlideConfigDialog extends React.Component {

  /*state = {
    share: true,    
  };*/

  componentDidMount() {     
  }

  handleClose = (evt) => {
    this.props.dispatch(closeConfig());  
  }
  
  handleChange = name => event => {
    //this.setState({ [name]: event.target.checked });
    let config = platformHandler.getConfigPPT();
    config[name] = event.target.checked;
    platformHandler.setConfigSlides( config );
  };

  render() {
    const { classes, configPPT } = this.props;
    
    const { configWindow } = this.context.store.getState().containers.appReducer;

    console.log('La recibe en ',this.props.configPPT)

    //let showTitle = modalWindow.title != '' && modalWindow.title != undefined;

    return (
      <React.Fragment>        
        <Dialog
          open={configWindow.opened}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.paperDialog }}          
        >
          <div className={classes.paperTitle}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleClose}                
              className={classes.menuButton}
              classes={{label:classes.iconMenuBar}}
            >
              <ArrowBackIcon />
            </IconButton>
            <div className={classes.labelTitlePaper}>{languageManager.getLangWord('CONFIG_OF') + ' ' + this.props.slideName}</div>
          </div>  
          <div >
            <div className={classes.allItemsContainer}>
              <div className={classes.configContainer}>
                <div className={classes.configItemBlock} style={{flexDirection: 'column'}}>
                  <div style={{display: 'flex',}}> 
                    <div className={classes.instructionContainer}>
                      <div className={classes.configItemTitle}>{languageManager.getLangWord('TITLE_SHARE')}</div>
                      <div className={classes.configItemDesc}>{languageManager.getLangWord('DESC_SHARE')}</div>
                    </div>
                    <div className={classes.switchContainer}>
                      {languageManager.getLangWord('NO')} <Switch checked={this.props.configPPT.shareFinish} onChange={this.handleChange('shareFinish')} value='share'/> {languageManager.getLangWord('YES')}
                    </div>
                  </div>
                  {/*<div className={classes.shareBox}>
                    Link para la presentación compartida: <a href="https://www.fwtap.com/v=1576077875757">https://www.fwtap.com/v=1576077875757</a>
                  </div>*/}
                </div>
              </div>            
            </div> 

            <div className={classes.allItemsContainer}>
              <div className={classes.configContainer}>
                <div className={classes.configItemBlock}>
                  <div className={classes.instructionContainer}>
                    <div className={classes.configItemTitle}>{languageManager.getLangWord('REQUEST_NICK')}</div>
                    <div className={classes.configItemDesc}>{languageManager.getLangWord('DESC_REQUEST_NICK')}</div>
                  </div>
                  <div className={classes.switchContainer}>
                    {languageManager.getLangWord('NO')} <Switch checked={this.props.configPPT.nick} onChange={this.handleChange('nick')} value='nick'/> {languageManager.getLangWord('YES')}
                  </div>
                </div>
              </div>            
            </div>  

            <div className={classes.allItemsContainer}>
              <div className={classes.configContainer}>
                <div className={classes.configQuestionsBlock}>
                  <div className={classes.configQuestions}>
                    <div className={classes.instructionContainer}>
                      <div className={classes.configItemTitle}>{languageManager.getLangWord('ALLOW_QUESTIONS')}</div>
                      <div className={classes.configItemDesc}>{languageManager.getLangWord('DESC_ALLOW_QUESTIONS')}</div>
                    </div>
                    <div className={classes.switchContainer}>
                      {languageManager.getLangWord('NO')} <Switch checked={configPPT.showQuestionButton} onChange={this.handleChange('showQuestionButton')} value='questions'/> {languageManager.getLangWord('YES')}
                    </div>
                  </div>
                  
                    <div className={classes.configModerator} style={{opacity: configPPT.showQuestionButton ? 1 : 0.5, pointerEvents: configPPT.showQuestionButton ? 'auto': 'none'}}>
                      <div className={classes.instructionContainer}>
                        <div className={classes.configItemTitle}>{languageManager.getLangWord('ENABLE_MODERATOR')}</div>
                        <div className={classes.configItemDesc}>{languageManager.getLangWord('DESC_MODERATOR')}</div>
                      </div>
                      <div className={classes.switchContainer}>
                        {languageManager.getLangWord('NO')} <Switch checked={this.props.configPPT.moderator} onChange={this.handleChange('moderator')} value='moderator'/> {languageManager.getLangWord('YES')}
                      </div>
                    </div>
                 
                  
                </div>                                                         
              </div>            
            </div>                     
          </div>
        </Dialog>
      </React.Fragment>      
    );
  }
}  
  
FwSlideConfigDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

FwSlideConfigDialog.contextTypes = {
  store: PropTypes.object,
};

const mapStateToProps = state => {  
  return {
    configWindow: state.containers.appReducer.configWindow,  
    configPPT: state.containers.appReducer.configPPT,  
    slideName: state.containers.appReducer.currentData.slideName,
  }
};

export default connect(mapStateToProps)(withStyles(styles,{ withTheme: true })(FwSlideConfigDialog));



// WEBPACK FOOTER //
// ./src/containers/components/FwSlideConfigDialog.js